import { render, staticRenderFns } from "./PackagePeriodItem.vue?vue&type=template&id=4e16abf8"
import script from "./PackagePeriodItem.vue?vue&type=script&lang=js"
export * from "./PackagePeriodItem.vue?vue&type=script&lang=js"
import style0 from "./PackagePeriodItem.vue?vue&type=style&index=0&id=4e16abf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports